export default "__VITE_ASSET__4ec88847__"